import { DiagnosticCardStat } from '@Scenes/RightsholderScene/RightsholderDashboard/MemberHubDiagnostic/DashboardDiagnosticCard'
import { MemberActionDiagnostic } from '@Entities/member/member-action-diagnostic'
import UserStore from '@App/stores/user/user-store'
import { UserSettings } from '@Entities/user/user'
import Navigation from '@App/navigation'

interface DiagnosticCardData {
    key: string
    title: string
    isCollapsed: boolean
    setIsCollapsed(): void
    stats: DiagnosticCardStat[]
}

export const buildDiagnosticCards = (
    diagnostic: MemberActionDiagnostic,
    rightsholderId: number,
    userStore: UserStore,
    userSettings?: UserSettings
): DiagnosticCardData[] => {
    const cards: DiagnosticCardData[] = []

    const openOverclaimsStats = [
        {
            count: diagnostic.openOverclaimsDiagnostic?.openOverclaims,

            label: 'Active',
            linkText: 'Review Overviews',
            linkUrl: Navigation.rightholder.overclaim.root(rightsholderId),
        },
        {
            count: diagnostic.openOverclaimsDiagnostic?.overclaimNeedsDocumentation,
            label: 'Require action',
            linkText: 'Use the Overclaims Tool to take action',
            // Lands on the Overclaims Tool already filtered to the overclaims this stat counts.
            // The field names here (status, documentationStatus) must match OverclaimSearchFilters.
            linkUrl: `${Navigation.rightholder.overclaim.root(rightsholderId)}?status=OVERCLAIM&documentationStatus=DOCUMENT_NEEDED`,
        },
    ].filter((stat) => !!stat.count)
    if (openOverclaimsStats.length > 0) {
        cards.push({
            key: 'open-overclaims',
            title: 'Open Overclaims',
            isCollapsed: !!userSettings?.collapseOpenOverclaimsPanel,
            setIsCollapsed: () => userStore.changeUserSetting('collapseOpenOverclaimsPanel'),
            stats: openOverclaimsStats,
        })
    }

    // Temporarily disabled as MX checks with Legal over some stuff
    /* if (diagnostic.regHistoryActionCount) {
        cards.push({
            key: 'registration-history',
            isCollapsed: !!userSettings?.collapseRegistrationHistoryActionsPanel,
            setIsCollapsed: () => userStore.changeUserSetting('collapseRegistrationHistoryActionsPanel'),
            title: 'Registration History Actions',
            stats: [
                {
                    count: diagnostic.regHistoryActionCount,
                    linkText: 'Review and complete',
                    linkUrl: Navigation.rightholder.registrationHistory.needsAttention(rightsholderId),
                },
            ],
        })
    } */

    if (diagnostic.pendingCatalogTranDiagnostic) {
        cards.push({
            key: 'pending-catalog-transfers',
            isCollapsed: !!userSettings?.collapsePendingCatalogTransfersPanel,
            setIsCollapsed: () => userStore.changeUserSetting('collapsePendingCatalogTransfersPanel'),
            title: 'Catalog Transfer Requests to Review',
            stats: [
                {
                    count: diagnostic.pendingCatalogTranDiagnostic,
                    label: 'Requests submitted by other Members for works currently in your catalog',
                    linkText: 'View and take action',
                    // Lands on the "For My Review" tab already filtered to Submitted transfers. The
                    // query string must come before the tab hash; statusFilter must match CatalogTransferFilterCollection.
                    linkUrl: `${Navigation.rightholder.catalogTransfer.root(rightsholderId)}?statusFilter=SUBMITTED#for-my-review`,
                },
            ],
        })
    }

    if (diagnostic.registrationDraftCount) {
        cards.push({
            key: 'registration-drafts',
            isCollapsed: !!userSettings?.collapseRegistrationDraftsPanel,
            setIsCollapsed: () => userStore.changeUserSetting('collapseRegistrationDraftsPanel'),
            title: 'Unsubmitted Registrations',
            stats: [
                {
                    count: diagnostic.registrationDraftCount,
                    linkText: 'Complete your work registrations',
                    linkUrl: Navigation.rightholder.registrationDrafts.root(rightsholderId),
                },
            ],
        })
    }

    return cards
}
